<template>
    <div class="mileage_item_info">
        <div style="padding:16px;">
            <div style="display: flex;align-items: center;">
                <div style="background: #2A7AFF;width: 12px;height: 12px;border-radius: 50%;"></div>
                <div style="font-size: 12px;color: #0E193B;margin-left: 12px;">{{$t('driver.统计时间')}}：{{time}}</div>
            </div>
            <div style="display: flex;margin-top: 14px;">
                <div style="display: flex;flex-direction: column;flex: 1;text-align: center;">
                    <div style="font-size: 12px;color: #0E193B;">{{$t('driver.总里程')}}</div>
                    <div style="font-size: 20px;color: #0E193B;margin-top: 4px;font-weight: bold;">{{mileage}}</div>
                </div>
                <div style="display: flex;flex-direction: column;flex: 1;text-align: center;">
                    <div style="font-size: 12px;color: #0E193B;">{{$t('driver.总驾驶评分')}}</div>
                    <div style="font-size: 20px;color: #0E193B;margin-top: 4px;font-weight: bold;">{{score}}</div>
                </div>
            </div>

        </div>
        <div style="height: 1px;background: #D9E4F8;width: 100%;"></div>
    </div>
</template>
<script >
export default{
    props:{
        score:{
            type:Number,
            default:0
        },  mileage:{
            type:Number,
            default:0
        },  time:{
            type:String,
            default:''
        }
    }
}
</script>
<style scoped>
.mileage_item_info {
    background: #FFF;
    cursor: pointer;
}

.mileage_item_info:hover {
    background: #E8F0FF;
}
</style>
